"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var InfoIcon = function (props) { return (
// allow prop spreading for svg icon
// eslint-disable-next-line react/jsx-props-no-spreading
react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32" }, props),
    react_1.default.createElement("path", { id: "a", d: "M4,16a12,12 0 1,0 24,0a12,12 0 1,0 -24,0" }),
    react_1.default.createElement("path", { d: "M14.5 13v-3h3v3h-3zm0 9v-6h3v6h-3z", id: "b" }))); };
var StyledInfoIcon = styled_components_1.default(InfoIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  vertical-align: middle;\n  #a {\n    fill: ", ";\n  }\n  #b {\n    fill: ", ";\n  }\n"], ["\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  vertical-align: middle;\n  #a {\n    fill: ",
    ";\n  }\n  #b {\n    fill: ", ";\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '1rem' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '1rem' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '1rem' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '1rem' : _b;
    return size;
}, function (_a) {
    var component = _a.theme.component, _b = _a.level, level = _b === void 0 ? 'info' : _b;
    return component.notification[level].borderColor;
}, function (_a) {
    var component = _a.theme.component, _b = _a.level, level = _b === void 0 ? 'info' : _b;
    return component.notification[level].iconColor;
});
exports.default = StyledInfoIcon;
var templateObject_1;
//# sourceMappingURL=Info.js.map